import React, { useState } from 'react';
import MainContent from '../layout/MainContent';
import AudienceCategoryForm from './audienceCategories/AudienceCategoryForm';
import AudienceCategoryList from './audienceCategories/AudienceCategoryList';
import { ICON_NEW } from '../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addAudienceCategoriesAction } from '../../actions/audienceCategoriesActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const AudienceCategories = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addAudienceCategoriesAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Audiencia Categorías' 
                subtitle='Audiencias' 
                nodes={nodes}
                actions={actions}
                component={AudienceCategoryList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <AudienceCategoryForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default AudienceCategories;